import { Expose, Transform } from 'class-transformer'
import moment from 'moment'
import { Truck } from 'react-feather'

export class Driver {
  static type = 'driver'
  static typeDisplay = 'Driver'
  static icon = Truck

  type = Driver.type
  typeDisplay = Driver.typeDisplay
  icon = Driver.icon

  guid: string = ''

  email: string = ''
  phone?: string

  @Expose({ name: 'first_name' })
  firstName: string = ''

  @Expose({ name: 'last_name' })
  lastName: string = ''

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }

  get name() {
    return `Driver: ${this.firstName} ${this.lastName}`
  }

  @Expose({ name: 'profile_image' })
  profileImage?: string

  @Expose({ name: 'dl_state_code' })
  dlStateCode?: string

  @Expose({ name: 'dl_number' })
  dlNumber?: string

  @Expose({ name: 'dl_expires_on' })
  @Transform((value) => value ? moment(value) : value)
  dlExpiresOn?: moment.Moment

  @Expose({ name: 'dl_front' })
  dlFront?: string

  @Expose({ name: 'dl_back' })
  dlBack?: string
}
